// Version : 1.0.0
// Author : AGALYA

import SignatureActionType from './signature.types';

/** ***************** upload Signature Start ************************/
export const uploadSignatureStart = (signatureUploadCredentials: any) => ({
	type: SignatureActionType.UPLOAD_SIGNATURE_START,
	payload: signatureUploadCredentials,
});

export const uploadSignatureSuccess = (signatureUploadSuccess: any) => ({
	type: SignatureActionType.UPLOAD_SIGNATURE_SUCCESS,
	payload: signatureUploadSuccess,
});

export const uploadSignatureFailure = (signatureUploadFailure: any) => ({
	type: SignatureActionType.UPLOAD_SIGNATURE_FAILURE,
	payload: signatureUploadFailure,
});

export const uploadSignatureResponseResetStart = () => ({
	type: SignatureActionType.UPLOAD_SIGNATURE_RESPONSE_REST_START,
});

export const uploadSignatureUserResponseChanged = () => ({
	type: SignatureActionType.UPLOAD_SIGNATURE_RESPONSE_CHANGED,
});
/** ***************** upload Signature End ************************/
